export const GET_ALL_TAX_INVOICE = "GET_ALL_TAX_INVOICE";
export const GET_ALL_TAX_INVOICE_SUCCESS = "GET_ALL_TAX_INVOICE_SUCCESS";
export const GET_ALL_TAX_INVOICE_FAIL = "GET_ALL_TAX_INVOICE_FAIL";

export const GET_ALL_TAX_INVOICE_BUYER = "GET_ALL_TAX_INVOICE_BUYER";
export const GET_ALL_TAX_INVOICE_SUCCESS_BUYER =
  "GET_ALL_TAX_INVOICE_SUCCESS_BUYER";
export const GET_ALL_TAX_INVOICE_FAIL_BUYER = "GET_ALL_TAX_INVOICE_FAIL_BUYER";

export const GET_ALL_TAX_INVOICE_GEN = "GET_ALL_TAX_INVOICE_GEN";
export const GET_ALL_TAX_INVOICE_GEN_SUCCESS =
  "GET_ALL_TAX_INVOICE_GEN_SUCCESS";
export const GET_ALL_TAX_INVOICE_GEN_FAIL = "GET_ALL_TAX_INVOICE_GEN_FAIL";

export const GET_ALL_TAX_INVOICE_SALE = "GET_ALL_TAX_INVOICE_SALE";
export const GET_ALL_TAX_INVOICE_SALE_SUCCESS =
  "GET_ALL_TAX_INVOICE_SALE_SUCCESS";
export const GET_ALL_TAX_INVOICE_SALE_FAIL = "GET_ALL_TAX_INVOICE_SALE_FAIL";

export const GET_ALL_TAX_INVOICE_LOT = "GET_ALL_TAX_INVOICE_LOT";
export const GET_ALL_TAX_INVOICE_LOT_SUCCESS =
  "GET_ALL_TAX_INVOICE_LOT_SUCCESS";
export const GET_ALL_TAX_INVOICE_LOT_FAIL = "GET_ALL_TAX_INVOICE_LOT_FAIL";

export const GET_ALL_TAX_INVOICE_SESSION = "GET_ALL_TAX_INVOICE_SESSION";
export const GET_ALL_TAX_INVOICE_SESSION_SUCCESS =
  "GET_ALL_TAX_INVOICE_SESSION_SUCCESS";
export const GET_ALL_TAX_INVOICE_SESSION_FAIL =
  "GET_ALL_TAX_INVOICE_SESSION_FAIL";

export const GET_INVOICE_BY_ID = "GET_INVOICE_BY_ID";
export const GET_INVOICE_BY_ID_SUCCESS = "GET_INVOICE_BY_ID_SUCCESS";
export const GET_INVOICE_AUCTION_BY_ID_SUCCESS = "GET_INVOICE_AUCTION_BY_ID_SUCCESS";
export const GET_INVOICE_BY_ID_FAIL = "GET_INVOICE_BY_ID_FAIL";

export const GET_INVOICE_GST_BY_ID = "GET_INVOICE_GST_BY_ID";
export const GET_INVOICE_GST_BY_ID_SUCCESS = "GET_INVOICE_GST_BY_ID_SUCCESS";
export const GET_INVOICE_GST_BY_ID_FAIL = "GET_INVOICE_GST_BY_ID_FAIL";

export const GET_GST_EXCEL_BY_ID = "GET_GST_EXCEL_BY_ID";
export const GET_GST_EXCEL_BY_ID_SUCCESS = "GET_GST_EXCEL_BY_ID_SUCCESS";
export const GET_GST_EXCEL_BY_ID_FAIL = "GET_GST_EXCEL_BY_ID_FAIL";
export const GET_EXPORT_DATA_SELLER = "GET_EXPORT_DATA_SELLER";
export const GET_EXPORT_DATA_SELLER_SUCCESS = "GET_EXPORT_DATA_SELLER_SUCCESS";
export const GET_EXPORT_DATA_SELLER_FAIL = "GET_EXPORT_DATA_SELLER_FAIL";
export const GET_EXPORT_DATA_SELLER_API_CALL =
  "GET_EXPORT_DATA_SELLER_API_CALL";

export const GET_INVOICE_NOT_BY_ID = "GET_INVOICE_NOT_BY_ID";
export const GET_INVOICE_NOT_BY_SUCCESS = "GET_INVOICE_NOT_BY_SUCCESS";
export const GET_INVOICE_NOT_BY_FAIL = "GET_INVOICE_NOT_BY_FAIL";
export const INVOICE_API_STATUS = "INVOICE_API_STATUS";

export const API_STATUS_RESPONSE = "API_STATUS_RESPONSE";

export const ENABLE_INVOICE_GENERATE_BUTTON = 'ENABLE_INVOICE_GENERATE_BUTTON';
export const DISABLE_INVOICE_GENERATE_BUTTON = 'DISABLE_INVOICE_GENERATE_BUTTON';

export const ENABLE_SEARCH_BUTTON = 'ENABLE_SEARCH_BUTTON';
export const DISABLE_SEARCH_BUTTON = 'DISABLE_SEARCH_BUTTON';


export const ENABLE_INDIVIDUALBUYER_TAXINVOICE_SEARCH_BUTTON = 'ENABLE_INDIVIDUALBUYER_TAXINVOICE_SEARCH_BUTTON';
export const DISABLE_INDIVIDUALBUYER_TAXINVOICE_SEARCH_BUTTON = 'DISABLE_INDIVIDUALBUYER_TAXINVOICE_SEARCH_BUTTON';


export const ENABLE_EXPORT_IRN_DETAILS_BUTTON = 'ENABLE_EXPORT_IRN_DETAILS_BUTTON';
export const DISABLE_EXPORT_IRN_DETAILS_BUTTON = 'DISABLE_EXPORT_IRN_DETAILS_BUTTON';

export const ENABLE_IRN_UPLOAD_DOCUMENT_BUTTON = 'ENABLE_IRN_UPLOAD_DOCUMENT_BUTTON';
export const DISABLE_IRN_UPLOAD_DOCUMENT_BUTTON = 'DISABLE_IRN_UPLOAD_DOCUMENT_BUTTON';

export const EXPORTED_FILE_SUCCESS = 'EXPORTED_FILE_SUCCESS';
export const EXPORTED_FILE_FAILURE = 'EXPORTED_FILE_FAILURE'
export const EXPORTED_FILE_API_CALL = 'EXPORTED_FILE_API_CALL'
export const RESET_EXPORTED_FILE = 'RESET_EXPORTED_FILE';